const PaperSelector = ({ papers, selectedPaper, onSelect }) => {
  if (!papers?.length) {
    return (
      <div className="p-4 text-sm text-base-content/60">
        No papers available. Generate a report first.
      </div>
    );
  }

  return (
    <div className="flex h-full min-h-0 flex-col">
      <h3 className="border-b border-base-300 p-3 font-semibold text-base-content">
        Select a paper
      </h3>
      <ul className="min-h-0 flex-1 space-y-1 overflow-y-auto p-2">
        {papers.map((paper) => {
          const id = paper.file_id ?? paper.id ?? paper.file_name ?? paper.name;
          const label = paper.file_name ?? paper.filename ?? paper.name ?? `Paper ${id}`;
          const pmid = paper.pmid ?? "—";
          const isSelected = selectedPaper?.file_id === id || selectedPaper?.file_name === label;
          return (
            <li key={id}>
              <button
                type="button"
                className={`w-full rounded-lg px-3 py-2 text-left text-sm transition ${
                  isSelected ? "bg-primary text-primary-content" : "hover:bg-base-200"
                }`}
                onClick={() => onSelect(paper)}
              >
                <div className="font-medium truncate" title={label}>
                  {label}
                </div>
                <div className="mt-0.5 text-xs opacity-80">PMID: {pmid}</div>
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default PaperSelector;
